import { EventMessage, WebRTCUpMessage, SlowlinkMessage, MediaMessage, HangupMessage } from './message';
import { PluginMessageReceivable, PluginMessage, Session } from './session';
import { ignore } from 'utility/ignore';

export class PluginHandler implements PluginMessageReceivable {
    private readonly session: Session;
    private readonly handleId: number;

    constructor(session: Session, handleId: number) {
        this.session = session;
        this.handleId = handleId;

        session.addReceiver(handleId, this);
    }

    async trickle(candidate: RTCIceCandidateInit) {
        return await this.session.trickle(this.handleId, candidate);
    }

    protected async sendMessage<T extends {}>(payload: T) {
        return await this.session.sendMessage(this.handleId, payload);
    }

    onReceive(msg: PluginMessage) {
        switch (msg.janus) {
            case 'event':
                this.onevent(msg);
                break;
            case 'webrtcup':
                this.onwebrtcup(msg);
                break;
            case 'slowlink':
                this.onslowlink(msg);
                break;
            case 'media':
                this.onmedia(msg);
                break;
            case 'hangup':
                this.onhangup(msg);
                break;
        }
    }

    onevent(msg: EventMessage) {
        ignore(msg);
    }

    onwebrtcup(msg: WebRTCUpMessage) {
        ignore(msg);
    }

    onslowlink(msg: SlowlinkMessage) {
        ignore(msg);
    }

    onmedia(msg: MediaMessage) {
        ignore(msg);
    }

    onhangup(msg: HangupMessage) {
        ignore(msg);
    }
}
